/**
 * 产品数据源
 * 包含完整的产品数据结构和 mock 数据
 */

export const categories = [
  { id: 'power', name: '电源管理 (Power)' },
  { id: 'signal', name: '信号链 (Signal Chain)' },
  { id: 'mcu', name: '微控制器 (MCU)' },
  { id: 'wireless', name: '无线连接 (Wireless)' },
  { id: 'sensors', name: '传感器 (Sensors)' },
  { id: 'interface', name: '接口芯片 (Interface)' }
]

export const products = [
  // ========== 电源管理 (Power) ==========
  {
    id: 'WX-5000',
    brand: 'Water Core',
    model: 'WX-5000-DC24',
    name: 'WX-5000 降压转换器',
    category: 'power',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-5000',
    tag: 'New',
    specs: [
      { label: '封装', value: 'SOT-23' },
      { label: '品类', value: '降压转换器' },
      { label: '输入电压', value: '5V' },
      { label: '输出电流', value: '3A' },
      { label: '效率', value: '95%' },
      { label: '编码', value: 'WX5000-001' }
    ],
    certifications: ['RoHS', 'SMT', '扩展库'],
    pricing: [
      { quantity: 1, price: 12.50 },
      { quantity: 10, price: 11.80 },
      { quantity: 30, price: 10.50 },
      { quantity: 100, price: 9.20 },
      { quantity: 500, price: 8.50 },
      { quantity: 900, price: 7.90 }
    ],
    stock: {
      available: 900,
      status: 'in-stock',
      deliveryTime: '现货最快4小时发货'
    },
    description: '高效率降压转换器，适用于工业和汽车应用，支持宽输入电压范围，内置过流保护和热关闭功能。',
    datasheet: '/docs/WX-5000-datasheet.pdf',
    applications: ['工业控制', '汽车电子', '通信设备']
  },
  {
    id: 'WX-3300',
    brand: 'Water Core',
    model: 'WX-3300-LDO',
    name: 'WX-3300 LDO 稳压器',
    category: 'power',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-3300',
    tag: 'Hot',
    specs: [
      { label: '封装', value: 'SOT-23' },
      { label: '品类', value: 'LDO 稳压器' },
      { label: '输入电压', value: '12V max' },
      { label: '输出电流', value: '300mA' },
      { label: '噪声', value: '20uV RMS' },
      { label: '编码', value: 'WX3300-001' }
    ],
    certifications: ['RoHS', '扩展库'],
    pricing: [
      { quantity: 1, price: 2.30 },
      { quantity: 10, price: 2.10 },
      { quantity: 100, price: 1.85 },
      { quantity: 1000, price: 1.50 }
    ],
    stock: {
      available: 2500,
      status: 'in-stock',
      deliveryTime: '现货最快2小时发货'
    },
    description: '超低噪声 LDO 稳压器，适合模拟电源应用。具有出色的纹波抑制和温度稳定性。',
    datasheet: '/docs/WX-3300-datasheet.pdf',
    applications: ['音频设备', '精密测量', '医疗仪器']
  },
  {
    id: 'WX-7000',
    brand: 'Water Core',
    model: 'WX-7000-BMS',
    name: 'WX-7000 电池管理系统',
    category: 'power',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-7000',
    tag: '',
    specs: [
      { label: '封装', value: 'BGA-16' },
      { label: '品类', value: '电池管理芯片' },
      { label: '充电电流', value: '5A max' },
      { label: '放电电流', value: '10A max' },
      { label: '工作温度', value: '-20~60℃' },
      { label: '编码', value: 'WX7000-001' }
    ],
    certifications: ['RoHS', 'SMT', '扩展库'],
    pricing: [
      { quantity: 1, price: 8.50 },
      { quantity: 10, price: 7.80 },
      { quantity: 50, price: 6.90 },
      { quantity: 500, price: 5.50 }
    ],
    stock: {
      available: 450,
      status: 'low-stock',
      deliveryTime: '现货最快6小时发货'
    },
    description: '单节锂电池管理芯片，集成充电、放电和保护功能。支持多种保护方式和通信接口。',
    datasheet: '/docs/WX-7000-datasheet.pdf',
    applications: ['移动电源', '可穿戴设备', '无线传感器']
  },

  // ========== 信号链 (Signal Chain) ==========
  {
    id: 'WX-200',
    brand: 'Water Core',
    model: 'WX-200-OPAMP',
    name: 'WX-200 运算放大器',
    category: 'signal',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-200',
    tag: 'New',
    specs: [
      { label: '封装', value: 'DIP-8' },
      { label: '品类', value: '通用运算放大器' },
      { label: '带宽', value: '10MHz' },
      { label: '增益', value: '100dB' },
      { label: '噪声', value: '15nV/√Hz' },
      { label: '编码', value: 'WX200-001' }
    ],
    certifications: ['RoHS', '扩展库'],
    pricing: [
      { quantity: 1, price: 1.20 },
      { quantity: 10, price: 1.05 },
      { quantity: 100, price: 0.95 },
      { quantity: 1000, price: 0.80 }
    ],
    stock: {
      available: 5000,
      status: 'in-stock',
      deliveryTime: '现货最快1小时发货'
    },
    description: '精密低噪声运算放大器，适用于精密传感和测量应用。',
    datasheet: '/docs/WX-200-datasheet.pdf',
    applications: ['传感器前端', '精密测量', '医疗仪器']
  },
  {
    id: 'WX-ADC12',
    brand: 'Water Core',
    model: 'WX-ADC12-SAR',
    name: 'WX-ADC12 12位 SAR ADC',
    category: 'signal',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-ADC12',
    tag: '',
    specs: [
      { label: '分辨率', value: '12-bit' },
      { label: '采样率', value: '1MSPS' },
      { label: '封装', value: 'QFN-16' },
      { label: '功耗', value: '5mW @ 1MHz' },
      { label: '输入范围', value: '0-3.3V' },
      { label: '编码', value: 'WX-ADC12-001' }
    ],
    certifications: ['RoHS', 'SMT'],
    pricing: [
      { quantity: 1, price: 3.50 },
      { quantity: 10, price: 3.10 },
      { quantity: 100, price: 2.70 },
      { quantity: 500, price: 2.30 }
    ],
    stock: {
      available: 1200,
      status: 'in-stock',
      deliveryTime: '现货最快4小时发货'
    },
    description: '低功耗 12 位 SAR 型 ADC，集成片上参考电压和采样保持电路。',
    datasheet: '/docs/WX-ADC12-datasheet.pdf',
    applications: ['数据采集', '工业控制', '医疗设备']
  },

  // ========== 微控制器 (MCU) ==========
  {
    id: 'WX-M32',
    brand: 'Water Core',
    model: 'WX-M32-ARM',
    name: 'WX-M32 32位 ARM MCU',
    category: 'mcu',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-M32',
    tag: 'Hot',
    specs: [
      { label: '处理器', value: 'Cortex-M4' },
      { label: '主频', value: '120MHz' },
      { label: '闪存', value: '256KB' },
      { label: 'RAM', value: '32KB' },
      { label: '封装', value: 'LQFP-100' },
      { label: '编码', value: 'WX-M32-001' }
    ],
    certifications: ['RoHS', 'SMT', '扩展库'],
    pricing: [
      { quantity: 1, price: 5.80 },
      { quantity: 10, price: 5.20 },
      { quantity: 100, price: 4.50 },
      { quantity: 1000, price: 3.80 }
    ],
    stock: {
      available: 3200,
      status: 'in-stock',
      deliveryTime: '现货最快3小时发货'
    },
    description: '高性能 32 位 ARM Cortex-M4 微控制器，集成丰富的外设和通信接口。',
    datasheet: '/docs/WX-M32-datasheet.pdf',
    applications: ['工业控制', '智能家居', '物联网应用']
  },
  {
    id: 'WX-L10',
    brand: 'Water Core',
    model: 'WX-L10-ULTRA-LOW',
    name: 'WX-L10 超低功耗 MCU',
    category: 'mcu',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-L10',
    tag: '',
    specs: [
      { label: '处理器', value: 'Cortex-M0+' },
      { label: '主频', value: '16MHz' },
      { label: '闪存', value: '64KB' },
      { label: 'RAM', value: '8KB' },
      { label: '待机功耗', value: '0.5uA' },
      { label: '编码', value: 'WX-L10-001' }
    ],
    certifications: ['RoHS', '扩展库'],
    pricing: [
      { quantity: 1, price: 2.40 },
      { quantity: 10, price: 2.15 },
      { quantity: 100, price: 1.90 },
      { quantity: 500, price: 1.60 }
    ],
    stock: {
      available: 1800,
      status: 'in-stock',
      deliveryTime: '现货最快4小时发货'
    },
    description: '超低功耗微控制器，适用于电池供电的物联网设备，待机功耗极低。',
    datasheet: '/docs/WX-L10-datasheet.pdf',
    applications: ['IoT传感器', '穿戴设备', '远程控制']
  },

  // ========== 无线连接 (Wireless) ==========
  {
    id: 'WX-BT5',
    brand: 'Water Core',
    model: 'WX-BT5-BLE52',
    name: 'WX-BT5 蓝牙 5.2 SoC',
    category: 'wireless',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-BT5',
    tag: 'New',
    specs: [
      { label: '标准', value: 'Bluetooth 5.2' },
      { label: '射程', value: '240m (coded mode)' },
      { label: '数据率', value: '2Mbps' },
      { label: '功耗', value: '4.7mA TX, 2.9mA RX' },
      { label: '频率', value: '2.4GHz ISM' },
      { label: '编码', value: 'WX-BT5-001' }
    ],
    certifications: ['RoHS', '扩展库', 'FCC'],
    pricing: [
      { quantity: 1, price: 6.50 },
      { quantity: 10, price: 5.90 },
      { quantity: 100, price: 5.20 },
      { quantity: 500, price: 4.50 }
    ],
    stock: {
      available: 800,
      status: 'low-stock',
      deliveryTime: '现货最快8小时发货'
    },
    description: '集成蓝牙 5.2 的高性能 SoC，支持 BLE 和经典蓝牙，集成射频前端。',
    datasheet: '/docs/WX-BT5-datasheet.pdf',
    applications: ['医疗设备', '健身追踪器', '音频设备']
  },
  {
    id: 'WX-WF6',
    brand: 'Water Core',
    model: 'WX-WF6-WIFI6',
    name: 'WX-WF6 WiFi 6 模块',
    category: 'wireless',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-WF6',
    tag: '',
    specs: [
      { label: '标准', value: 'IEEE 802.11ax' },
      { label: '速率', value: '9.6Gbps' },
      { label: '带宽', value: '20/40/80MHz' },
      { label: '功耗', value: '低功耗设计' },
      { label: '温度范围', value: '-20~70℃' },
      { label: '编码', value: 'WX-WF6-001' }
    ],
    certifications: ['RoHS', 'SMT', 'FCC', 'CE'],
    pricing: [
      { quantity: 1, price: 18.50 },
      { quantity: 10, price: 16.80 },
      { quantity: 50, price: 15.20 },
      { quantity: 100, price: 13.50 }
    ],
    stock: {
      available: 320,
      status: 'low-stock',
      deliveryTime: '现货最快12小时发货'
    },
    description: '最新 WiFi 6 标准无线模块，支持高速数据传输和低功耗操作，集成嵌入式协议栈。',
    datasheet: '/docs/WX-WF6-datasheet.pdf',
    applications: ['智能家居', '流媒体设备', '高带宽应用']
  },

  // ========== 传感器 (Sensors) ==========
  {
    id: 'WX-T1',
    brand: 'Water Core',
    model: 'WX-T1-TEMP',
    name: 'WX-T1 精密温度传感器',
    category: 'sensors',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-T1',
    tag: 'New',
    specs: [
      { label: '测量范围', value: '-20~85℃' },
      { label: '精度', value: '±0.1℃' },
      { label: '分辨率', value: '0.0625℃' },
      { label: '接口', value: 'I2C/SMBus' },
      { label: '封装', value: 'SO-8' },
      { label: '编码', value: 'WX-T1-001' }
    ],
    certifications: ['RoHS', 'SMT'],
    pricing: [
      { quantity: 1, price: 2.20 },
      { quantity: 10, price: 1.95 },
      { quantity: 100, price: 1.70 },
      { quantity: 1000, price: 1.45 }
    ],
    stock: {
      available: 4500,
      status: 'in-stock',
      deliveryTime: '现货最快2小时发货'
    },
    description: '高精度集成温度传感器，支持 I2C 和 SMBus 接口，功耗极低。',
    datasheet: '/docs/WX-T1-datasheet.pdf',
    applications: ['温度监测', '热管理', '环保设备']
  },

  // ========== 接口芯片 (Interface) ==========
  {
    id: 'WX-485',
    brand: 'Water Core',
    model: 'WX-485-TRANCEIVER',
    name: 'WX-485 RS-485 收发器',
    category: 'interface',
    image: 'https://via.placeholder.com/400x300/005eb8/ffffff?text=WX-485',
    tag: '',
    specs: [
      { label: '标准', value: 'EIA RS-485' },
      { label: '通信模式', value: '半双工' },
      { label: '速率', value: '最高 1Mbps' },
      { label: 'ESD 保护', value: '±15kV' },
      { label: '封装', value: 'DIP-8' },
      { label: '编码', value: 'WX-485-001' }
    ],
    certifications: ['RoHS', '扩展库'],
    pricing: [
      { quantity: 1, price: 1.50 },
      { quantity: 10, price: 1.30 },
      { quantity: 100, price: 1.10 },
      { quantity: 1000, price: 0.95 }
    ],
    stock: {
      available: 6000,
      status: 'in-stock',
      deliveryTime: '现货最快1小时发货'
    },
    description: '工业级 RS-485 收发器，集成强大的 ESD 保护，适用于工业通信应用。',
    datasheet: '/docs/WX-485-datasheet.pdf',
    applications: ['工业自动化', '楼宇控制', '能源管理']
  }
]

/**
 * 获取指定分类的产品列表
 * @param {string} category - 分类 ID
 * @returns {Array} 产品数组
 */
export const getProductsByCategory = (category) => {
  return products.filter(p => p.category === category)
}

/**
 * 根据产品 ID 获取产品信息
 * @param {string} id - 产品 ID
 * @returns {Object|undefined} 产品对象
 */
export const getProductById = (id) => {
  return products.find(p => p.id === id)
}

/**
 * 获取精选产品（带 Hot 或 New 标签）
 * @param {number} limit - 返回数量限制
 * @returns {Array} 精选产品数组
 */
export const getFeaturedProducts = (limit = 8) => {
  return products.filter(p => p.tag === 'Hot' || p.tag === 'New').slice(0, limit)
}

/**
 * 搜索产品
 * @param {string} keyword - 搜索关键词
 * @returns {Array} 匹配的产品数组
 */
export const searchProducts = (keyword) => {
  const lowerKeyword = keyword.toLowerCase()
  return products.filter(p =>
    p.name.toLowerCase().includes(lowerKeyword) ||
    p.model.toLowerCase().includes(lowerKeyword) ||
    p.brand.toLowerCase().includes(lowerKeyword)
  )
}
